{
  "slug": "iq-full-form",
  "title": "IQ Full Form: What Does IQ Stand For?",
  "description": "IQ stands for intelligence quotient. Understand where the term came from and what a modern IQ score actually represents.",
  "summary": "The full form of IQ is intelligence quotient. Modern IQ scores are standardized comparisons with an age-based norm group rather than literal quotients of mental age divided by chronological age.",
  "category": "IQ essentials",
  "sections": [
    {
      "heading": "The meaning of the abbreviation",
      "paragraphs": [
        "IQ is short for intelligence quotient. The name survives from early scoring methods, but contemporary tests usually derive scores statistically from performance in a reference sample.",
        "A score near 100 generally indicates performance near the center of the relevant norm group. It does not mean that someone has 100 units of intelligence."
      ]
    },
    {
      "heading": "Why “quotient” can be misleading today",
      "paragraphs": [
        "Early formulas compared an estimate of mental age with chronological age. That approach had important limitations, especially for adults, and modern instruments generally use deviation-based standard scores instead.",
        "The historical label remains familiar, while the underlying measurement has changed. Always interpret a score using the manual and norms for the particular test."
      ]
    },
    {
      "heading": "What IQ does and does not summarize",
      "paragraphs": [
        "A composite may summarize several cognitive domains, but people can have uneven profiles. Similar totals can arise from different patterns of strengths and difficulties.",
        "IQ is one source of information. Education, health, language, opportunity, motivation, personality, and environment also matter when explaining real-world outcomes."
      ]
    }
  ],
  "faqs": [
    {
      "question": "What is the IQ full form in English?",
      "answer": "IQ stands for intelligence quotient."
    },
    {
      "question": "Is IQ still calculated as mental age divided by actual age?",
      "answer": "Usually not. Modern tests generally compare performance with age-based norms and convert it to standardized scores."
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "APA Dictionary of Psychology — intelligence test",
      "url": "https://dictionary.apa.org/intelligence-test"
    }
  ]
}
